import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a338b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forgotten-password" }
const _hoisted_2 = { class: "forgotten-password__container forgotten-password__container--small" }
const _hoisted_3 = { class: "forgotten-password__header" }
const _hoisted_4 = { class: "forgotten-password__description" }
const _hoisted_5 = {
  key: 0,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_6 = ["disabled"]

import TressTextInput from "@/components/TressTextInput.vue";
import dictionary from "./../../i18n/dictionary.json";
import { ref } from "vue";
import { MemberApi } from "@/services/Api";
import TressFormSuccess from "@/components/TressFormSuccess.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccountForgottenPasswordForm',
  emits: ["backClick"],
  setup(__props, { emit }) {

const isSending = ref<boolean>(false);
const hasSuccess = ref<boolean>(false);


const onBackClick = () => {
  emit("backClick");
};

const onSubmit = async ({ email }: { email: string }) => {
  try {
    isSending.value = true;
    await MemberApi.forgottenPassword(email);
    hasSuccess.value = true;
  } catch (e) {
    hasSuccess.value = true;
  } finally {
    isSending.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!hasSuccess.value)
      ? (_openBlock(), _createBlock(_component_v_form, {
          key: 0,
          class: "forgotten-password__container",
          onSubmit: onSubmit
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).account.forgottenPasswordHeader)), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(_unref(dictionary).account.forgottenPasswordDescription)), 1)
            ]),
            _createVNode(TressTextInput, {
              label: _ctx.$t(_unref(dictionary).form.email.label),
              name: "email",
              rules: "required|email"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.email.label)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _withDirectives(_createVNode(_component_v_field, { name: "" }, null, 512), [
              [_vShow, false]
            ]),
            (errors[''])
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors[""]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "button forgotten-password__submit-button",
              disabled: isSending.value
            }, _toDisplayString(_ctx.$t(_unref(dictionary).account.sendRecoveryLink)), 9, _hoisted_6)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!hasSuccess.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "button forgotten-password__button",
          onClick: onBackClick
        }, _toDisplayString(_ctx.$t(_unref(dictionary).account.backToLogin)), 1))
      : (_openBlock(), _createBlock(TressFormSuccess, { key: 2 }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).account.forgottenPasswordSuccessHeader)), 1)
          ]),
          description: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).account.forgottenPasswordSuccessDescription)), 1)
          ]),
          _: 1
        }))
  ]))
}
}

})